import { render, staticRenderFns } from "./MnemonicBadge.vue?vue&type=template&id=789961a6&scoped=true"
import script from "./MnemonicBadge.vue?vue&type=script&lang=js"
export * from "./MnemonicBadge.vue?vue&type=script&lang=js"
import style0 from "./MnemonicBadge.vue?vue&type=style&index=0&id=789961a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789961a6",
  null
  
)

export default component.exports